import React from 'react'
import { WhenModel } from '@morningtrain/react-resources'
import ScheduleVacationRequestsSmartview from 'widgets/smartviews/shifts/ScheduleVacationRequestsSmartview'
import ScheduleDaySummarySmartview from 'widgets/smartviews/shifts/ScheduleDaySummarySmartview'
import SchedulePeriodSummarySmartview from 'widgets/smartviews/shifts/SchedulePeriodSummarySmartview'
import { Translation } from '@morningtrain/react-translations'
import MountSmartviewWithModelOnClick from 'support/utilities/MountSmartviewWithModelOnClick'

function ScheduleSmartViewTabs (props) {
  function getActiveClass (tab) {
    if (tab === props.active) {
      return 'btn-outlineDark'
    }
    return 'btn-outlineLight'
  }

  return (
    <WhenModel>
      <div className='flex justify-between group space-x-2 mb-8'>
        <MountSmartviewWithModelOnClick smartview={<SchedulePeriodSummarySmartview/>} replace>
          <button className={'btn btn-tall ' + getActiveClass('period_summary')}>
            <Translation name='generic.period'/>
          </button>
        </MountSmartviewWithModelOnClick>
        <MountSmartviewWithModelOnClick smartview={<ScheduleDaySummarySmartview/>} replace>
          <button className={'btn btn-tall ' + getActiveClass('day_summary')}>
            <Translation name='generic.day'/>
          </button>
        </MountSmartviewWithModelOnClick>
        <MountSmartviewWithModelOnClick smartview={<ScheduleVacationRequestsSmartview/>} replace>
          <button className={'btn btn-tall ' + getActiveClass('vacation_requests')}>
            <Translation name='generic.vacation'/>
          </button>
        </MountSmartviewWithModelOnClick>
      </div>
    </WhenModel>
  )
}

export default ScheduleSmartViewTabs
